import $ from 'jquery';
import {
  NOVITA_EMBED_CHAT_MESSAGE_TYPE,
  NOVITA_EMBED_GO_BACK_MESSAGE_TYPE,
  NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE,
  NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE,
  NOVITA_EMBED_URL,
  NOVITA_EMBED_VIEWED_MESSAGE_TYPE,
  NOVITA_TRACK_EVENT_NAMES,
} from './config';
import {
  normalizeNovitaEmbedNavigationUrl,
  parseNovitaEmbedMessage,
} from './embedTracking';
import { emitNovitaState } from './events';
import { saveNovitaItemsOpened, saveNovitaOpened } from './state';
import { trackEvent } from '~src/tracking/trackEvent';
import triggerChatFlow from '~src/utils/triggerChatFlow';

const MODAL_ID = 'modalNovitaEmbed';

const getNovitaTitle = () => 'Novità';

const getNovitaEmbedFrameWindow = () => {
  const iframe = $(`#${MODAL_ID} iframe[data-novita-embed-frame]`)[0];
  return iframe?.contentWindow || null;
};

const getNovitaEmbedSurface = (fallbackSurface) => {
  const iframe = $(`#${MODAL_ID} iframe[data-novita-embed-frame]`)[0];
  const surface = iframe ? $(iframe).data('novitaSurface') : null;
  return typeof surface === 'string' && surface
    ? surface
    : fallbackSurface || 'giotto_private_navbar';
};

const trackNovitaEmbed = (event, surface) => {
  const eventName = NOVITA_TRACK_EVENT_NAMES[event];
  if (!eventName) return;

  trackEvent(eventName, {
    surface,
    shell: 'giotto',
    entry_point: surface.replace(/^giotto_/, ''),
    embed_url: NOVITA_EMBED_URL,
  });
};

const openNovitaEmbedUrl = (url) => {
  const normalizedUrl = normalizeNovitaEmbedNavigationUrl(url);
  if (!normalizedUrl) return;

  const openedWindow = window.open(
    normalizedUrl,
    '_blank',
    'noopener,noreferrer'
  );
  if (openedWindow) openedWindow.opener = null;
};

const navigateNovitaEmbedFrame = (fallbackUrl) => {
  const iframe = $(`#${MODAL_ID} iframe[data-novita-embed-frame]`)[0];
  if (!iframe) return;

  iframe.src =
    normalizeNovitaEmbedNavigationUrl(fallbackUrl) || NOVITA_EMBED_URL;
};

const bindNovitaEmbedMessageListener = () => {
  if (window.__giottoNovitaEmbedListenerBound) return;

  window.__giottoNovitaEmbedListenerBound = true;
  window.addEventListener('message', async (event) => {
    const message = parseNovitaEmbedMessage(event, getNovitaEmbedFrameWindow());
    if (!message) return;

    if (message.type === NOVITA_EMBED_CHAT_MESSAGE_TYPE) {
      triggerChatFlow();
      return;
    }

    if (message.type === NOVITA_EMBED_OPEN_URL_MESSAGE_TYPE) {
      openNovitaEmbedUrl(message.url);
      return;
    }

    if (message.type === NOVITA_EMBED_GO_BACK_MESSAGE_TYPE) {
      navigateNovitaEmbedFrame(message.fallbackUrl);
      return;
    }

    try {
      if (message.type === NOVITA_EMBED_VIEWED_MESSAGE_TYPE) {
        emitNovitaState(
          await saveNovitaOpened({
            id: message.id,
            slug: message.slug,
            publishedAt: message.publishedAt,
            surface: getNovitaEmbedSurface(),
            path: message.path,
            url: message.url,
          })
        );
      } else if (message.type === NOVITA_EMBED_MARK_ALL_READ_MESSAGE_TYPE) {
        emitNovitaState(
          await saveNovitaItemsOpened({
            ids: message.ids,
            surface: getNovitaEmbedSurface(),
            path: message.path,
            url: message.url,
          })
        );
      }
    } catch (error) {
      console.warn('[novita] read state update failed', error);
    }
  });
};

const ensureNovitaEmbedModal = (initialSurface) => {
  if ($(`#${MODAL_ID}`).length) return;

  const title = getNovitaTitle();
  $('body').append(`
    <div class="modal fade novita-embed-modal" tabindex="-1" role="dialog" id="${MODAL_ID}" aria-label="${title}">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close novita-embed-modal__close" data-dismiss="modal" aria-label="Chiudi">
            <span aria-hidden="true">&times;</span>
          </button>
          <iframe src="${NOVITA_EMBED_URL}" title="${title}" loading="lazy" data-novita-embed-frame="true" referrerpolicy="strict-origin-when-cross-origin" allow="clipboard-write; fullscreen" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  `);

  const $iframe = $(`#${MODAL_ID} iframe[data-novita-embed-frame]`);
  $iframe.data('novitaSurface', initialSurface);
  $iframe.on('load', function () {
    trackNovitaEmbed('loaded', $(this).data('novitaSurface') || initialSurface);
  });
};

export const openNovitaEmbedModal = (
  surface = 'giotto_private_navbar',
  embedUrl = null
) => {
  bindNovitaEmbedMessageListener();
  ensureNovitaEmbedModal(surface);

  const targetUrl =
    normalizeNovitaEmbedNavigationUrl(embedUrl) || NOVITA_EMBED_URL;
  const $iframe = $(`#${MODAL_ID} iframe[data-novita-embed-frame]`);

  $iframe.data('novitaSurface', surface);
  if ($iframe.attr('src') !== targetUrl) {
    $iframe.attr('src', targetUrl);
  }

  trackNovitaEmbed('opened', surface);
  $(`#${MODAL_ID}`).modal('show');
  $('.modal-backdrop').last().css('z-index', 10020);
};
